export default "__VITE_ASSET__CgrJ$YVN__"